const { getObjectValue } = require('@root/helpers');

module.exports = {
	// documents: (state) => state.documents,

	documents: (state) => (
		type,
		filters = null,
		displayQty = null,
		page = null,
		withSubordinates = false,
		searchQuery = null
	) => {
		const whoseDocuments = withSubordinates
			? 'subordinateDocuments'
			: 'documents';

		let documents = getObjectValue('documents', state, []);

		if (searchQuery) {
			searchQuery = searchQuery.toLowerCase();

			documents = _.filter(documents, function(document) {
				return (
					getObjectValue('name', document, '')
						.toLowerCase()
						.indexOf(searchQuery) >= 0 ||
					getObjectValue('number', document, '')
						.toLowerCase()
						.indexOf(searchQuery) >= 0
				);
			});
		}

		if (withSubordinates) {
			documents = _.concat(
				documents,
				getObjectValue('subordinateDocuments', state, [])
			);
		}

		documents = _.filter(documents, (document) => {
			if (type === 'all') {
				return true;
			}

			return document.type.toLowerCase() === type;
		});

		if (filters !== null) {
			documents = _.filter(documents, (document) => {
				let shouldPass = true;

				_.forEach(filters.criteria, (filter, key) => {
					if (filter.length && filter.indexOf(document[key]) === -1) {
						shouldPass = false;
						return false;
					} else if (
						filter &&
						typeof filter === 'number' &&
						filter !== document[key]
					) {
						return false;
					}
				});

				return shouldPass;
			});

			let order = [filters.sorting.orderby];

			if(filters.sorting.orderby === 'number') {
				order = [function(item) {
					return parseInt(item.number.replace(/^\D*(\d+)\D*$/g, '$1'));
				}, filters.sorting.orderby]
			}

			documents = _.orderBy(
				documents,
				order,
				filters.sorting.order
			);
		}

		if (displayQty === null) {
			return documents;
		} else if (page === null) {
			return _.chunk(documents, displayQty);
		}

		return _.chunk(documents, displayQty)[page];
	},

	totalDocumentPages: (state, getters) => (
		type,
		displayQty,
		filters = null,
		searchQuery
	) =>
		getters.documents(type, filters, displayQty, null, false, searchQuery)
			.length,

	currentDocument: (state, getters) => (number) => {
		return getters.currentDocumentBy('number', number);
	},

	currentDocumentById: (state, getters) => (id) => {
		return getters.currentDocumentBy('id', id);
	},

	currentDocumentBy: (state) => (field, value) => {
		let params = {};
		params[field] = value;

		let document = _.find(state.documents, params);

		if (!document) {
			document = _.find(state.subordinateDocuments, params);
		}

		return document;
	},

	itemWithHighestLeadTime: (state, getters) => (id) => {
		let document = getters.currentDocumentById(id);

		return _.maxBy(document.line_items, (item) => {
			if (item.part !== null) {
				return getObjectValue('part.lead_time', item, 0);
			}

			return 0;
		});
	},

	leadTime: (state, getters) => (id) => {
		return getObjectValue(
			'part.lead_time',
			getters.itemWithHighestLeadTime(id),
			0
		);
	},

	leadTimeMeasure: (state, getters) => (id) => {
		let document = getters.currentDocument(id);

		return getObjectValue(
			'part.lead_time_measure',
			getters.itemWithHighestLeadTime(id),
			'days'
		);
	},
};
